import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/card-saga/keywords';

const keywordApi = {
    getAll: async () => {
        const { data } = await http.get(`${API_PREFIX}`);
        return data;
    },

    store: async (body) => {
        const { data: keyword } = await http.post(`${API_PREFIX}`, body, {});
        return keyword;
    },

    //may get deleted
    getCardDetails: async (name) => {
        let { data } = await http.get(`${API_PREFIX}/${name}`);
        return data;
    },

    update: async (id, body) => {
        await http.put(`${API_PREFIX}/${id}`, body, {});
    },

    delete: async (id) => {
        await http.destroy(`${API_PREFIX}/${id}`);
    },
};

export default keywordApi;
